export const state = {
  isAuthenticate: false,
  customer: {},
  isPhoneValid: false,
  phone_number: "",
  isOtpValid: false,
  otp: "",
};
